import React from 'react'
import { withRouter } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Flex from 'typescript-styled-flex'
import { FormGroup } from '../../components/FormBuilder'
import useSize from '../../hooks/useSize'
import EmployeeForm from './EmployeeForm'
import { getEditEmployee, getEmployees, getEmployeeTab } from '../../reducers/employees/selectors'
import { EmployeesAction } from '../../reducers/employees/actionNames'
import Employee from './Employee'
import { Null } from '../Template/Sidebar/Menu/SidebarContent'
import Scrollbars from '../../components/Scrollbars/Scrollbars'
import { is } from '../../components/MediaQuery'
import { Mixpanel } from '../../utils/Mixpanel'
import styled from '../../theme'


function Employees({ history, mobile }: any) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const size = useSize()
  const tab = useSelector(getEmployeeTab)
  const employees = useSelector(getEmployees)
  const onClick = () => {
    Mixpanel.track('Employees List Add Employee Button Clicked', [])
    dispatch({ type: EmployeesAction.SetTab, payload: 1 })
  }
  const isDesktop = is.desktop()
  const editEmployee = useSelector(getEditEmployee)

  return (
    <>
      <Flex
        style={{
          padding: `20px 18px 10px`,
          paddingRight: !isDesktop && tab === 1 ? '0px' : '18px',
          width: '100%',
        }}
      >
        {tab === 1 ? (
          <EmployeeForm initialValues={editEmployee} />
        ) : (
          <>
            <Flex
              style={{
                width: isDesktop ? '50%' : '100%',
                maxWidth: '1200px',
              }}
            >
              <FormGroup.Render
                size={size}
                withoutBtnPadding={true}
                withButton={true}
                toggle={onClick}
                title={t('BED_3607_active_users')}
                className={'employees-form-btn'}
                column={true}
              >
                {isDesktop ? (
                  <>
                    <Scrollbars
                      renderTrackHorizontal={Null}
                      autoHeight={true}
                      autoHeightMin={'400px'}
                      autoHeightMax={`calc(100vh - 220px)`}
                    >
                      {employees.map(e => (
                        <Employee key={e.id} e={e} />
                      ))}
                    </Scrollbars>
                  </>
                ) : (
                  <>
                    {employees.map(e => (
                      <Employee key={e.id} e={e} />
                    ))}
                  </>
                )}
              </FormGroup.Render>
            </Flex>
            {isDesktop && (
              <Flex
                style={{
                  marginTop: '20px',
                  marginLeft: '40px',
                  flexDirection: 'column',
                }}
              >
                <BoldLabel>{t('BED_3610_how_add_employee')}</BoldLabel>
                <iframe width='560' height='315' src='https://www.youtube.com/embed/7ZaW71WCLxY?si=msJlFTBnpdnPfneT'
                        title='YouTube video player' frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                        allowFullScreen></iframe>
                <div>
                  <Label>
                    {t('BED_8483_have_questions_1')}{' '}
                    <a
                      href={t('helpcenter_employee_hyperlink_general')}
                      style={{
                        cursor: 'pointer',
                        color: '#00A541',
                      }}
                    >
                      {t('BED_8483_have_questions_2')}
                    </a>
                  </Label>
                </div>

              </Flex>
            )}
          </>
        )}
      </Flex>
    </>
  )
}

const Label = styled.span`
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
    /* or 200% */

    color: #000000;
`

const BoldLabel = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 28px;
  /* or 200% */

  color: #000000;
`

export default withRouter(Employees)
